// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popover-container{margin:auto;max-width:22em}.popover-container>input{background-color:#efefef;border:none;color:#000;display:block;font-size:14px;font-weight:100;letter-spacing:1px;margin:11px auto;max-width:22em;padding:4px 10px;width:90%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
